import { createContext, FC, PropsWithChildren, useContext, useState } from 'react';

type ComuniTabLockApi = {
  tabsLocked: boolean;
  setTabsLocked: (locked: boolean) => void;
};

const ComuniTabLockContext = createContext<ComuniTabLockApi | null>(null);

export const ComuniTabLockProvider: FC<PropsWithChildren> = ({ children }) => {
  const [tabsLocked, setTabsLocked] = useState(false);

  return <ComuniTabLockContext.Provider value={{ tabsLocked, setTabsLocked }}>{children}</ComuniTabLockContext.Provider>;
};

export const useComuniTabLock = (): ComuniTabLockApi => {
  const ctx = useContext(ComuniTabLockContext);
  if (!ctx) {
    throw new Error('useComuniTabLock must be used within a ComuniTabLockProvider');
  }
  return ctx;
};
